import axios from "axios";
import qs from "qs";
import crypto from "crypto";
const env = process.env.NODE_ENV;
// 创建axios实例
const service = axios.create({
    timeout: 0,
    headers: { "Content-Type": "application/json" }
});

// request拦截器
service.interceptors.request.use(
    config => {
        if (config.method == "post" || config.method == "POST") {
            config.data = qs.stringify(config.data);
        }
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

function decryption(data) {
    // "4d63a5b8"开发
    // bb430bcc测试的key
    //10975356生成的key
    const aesConf = {
        key: env === 'production' ?
            "10975356" : 'bb430bcc',
        iv: "0",
        padding: ""
    };
    let key = aesConf.key;
    let iv = aesConf.iv;
    // let padding = AES_conf.padding;
    var cipherChunks = [];
    var decipher = crypto.createDecipheriv("des-ecb", key, iv);
    decipher.setAutoPadding(true);
    cipherChunks.push(decipher.update(data, "base64", "utf8"));
    cipherChunks.push(decipher.final("utf8"));
    return cipherChunks.join("");
}
// respone拦截器
service.interceptors.response.use(
    response => {
        if (response.request.responseURL.indexOf("/nfplus-ncov-api/ncov") > -1) {
            if (process.env.NODE_ENV !== "development") {
                const d = decryption(response.data);
                response.data = JSON.parse(d);
            }

        }
        const { code, msg, data, success } = response.data;
        if (code === 200 && success) {
            return response.data;
        }
        if (code !== 200) {
            return Promise.reject({ code, message: msg, data });
        }
    },
    error => {
        let message = ``;
        const { status } = error.response || 500;
        const { url } = error.config;
        switch (status) {
            case 401:
                break;
            case 403:
                message =
                    process.env.NODE_ENV === "development" ?
                    `当前用户无权限请求接口${url}` :
                    "无权限进行相关操作，请反馈给网站提供者";
                break;
            case 404:
                message =
                    process.env.NODE_ENV === "development" ?
                    `接口${url}未找到` :
                    "请确认链接是否正确";
                break;
            case 500:
            case 502:
            case 504:
                message =
                    process.env.NODE_ENV === "development" ?
                    `服务器发生内部错误` :
                    "服务器异常，请稍后重试";
                break;
            default:
                message = "服务器异常，请稍后重试";
                break;
        }
        const errorResult = {
            code: status,
            message,
            data: ""
        };
        return Promise.reject(errorResult);
    }
);

const http = {
    get: function(url, data, config) {
        return service({ method: "get", url, params: data, ...config });
    },
    post: function(url, data, config) {
        config.headers = {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        };
        return service({
            method: "post",
            url,
            data,
            ...config
        });
    }
};
export { service, http };